import { Link } from "react-router-dom";
import "./NewButton.css";

export default function Button({ redirectTo, text, filled }) {
  return (
    <Link
      className={
        filled
          ? "newbutton-style filled"
          : "newbutton-style nonfilledtext-color"
      }
      to={redirectTo}
    >
      {text}
    </Link>
  );
}
